const purchasePaymentStatusEnum = Object.freeze({
    
    PENDING:       5,
    PARTIAL_PAID : 10,
    FULLY_PAID   : 15,
});
export default purchasePaymentStatusEnum;
